import { type QuizQuestionRank } from '@efdigital/ll-addon-data';
import Component from '@glimmer/component';

import type { QuizQuestionResponseEditorComponentSignature } from '../../types/question-manager';
import CollapsibleResponse from './shared/collapsible-response.gts';

export class RankResponseEditorComponent extends Component<QuizQuestionResponseEditorComponentSignature> {
  get questionData(): QuizQuestionRank {
    return this.args.question.rank!;
  }

  <template>
    <div class="card-body p-0">
      <div class="form-label p-3">Configure responses based on whether the user
        ranks the options:</div>

      <CollapsibleResponse
        @label="Response if answered"
        @response={{this.questionData.response}}
      />

      <CollapsibleResponse
        @label="Response if blank"
        @response={{this.questionData.response0}}
      />
    </div>
  </template>
}
